<div class="reply-preview">
  <!-- <strong>{{ parentMessage.sender.nickname }}：</strong>
    <span>{{ parentMessage.message }}</span> -->

  <i class="fi-reply-filled"></i>
  <div class="reply-text">
    <span class="nickname">
      {{ parentMessage?.sender?.nickname || 'Unknown' }}
    </span>
    <span>:</span>
    <span class="text">{{ parentMessage?.message || '[empty]' }}</span>
  </div>
  <i class="fi-x" (click)="cancel()"></i>
</div>
